import React from "react";
import "./Team.css"; // Make sure to create and include this CSS file
import team1 from '../../img/team1.jpg'; 
import team2 from '../../img/team2.jpg'; 
import team3 from '../../img/team3.jpg'; 
import team4 from '../../img/team4.jpg'; 

const Team = () => {
  const teamMembers = [
    {
      name: "Ar. Neeraj Godse",
      role: "Founder, Principal, Pune HQ head",
      image: team1, // Replace with actual image path or URL
    },
    {
      name: "Sagarika Rajurkar",
      role: "Intern",
      image: team2,
    },
    {
      name: "Ar. Sourabh Marathe",
      role: "Advisory Expert",
      image: team1, // Replace with actual image path or URL
    },
    {
      name: "Dr. Yogesh Prabhudesai ",
      role: "Advisory Expert, Kolhapur Circle head",
      image: team3,
    },
    {
      name: "Anuja Patwardhan",
      role: "Advisory Expert",
      image: team2,
    },
    {
      name: "Dr. Harshada Wirkud",
      role: "Advisory Expert, Mumbai Circle head",
      image: team4,
    },
   
   
  ];
  return (
    <div className="team-section">
      <h2 className="team-title">Our <span className="highlight-team">Team</span></h2>
      <p className="team-description">
        We’re a team of explorers, innovators, and customer-focused professionals
        who are passionate about making travel easy and accessible for everyone.
      </p>
      <div className="team-members">
        {teamMembers.map((member, index) => (
          <div key={index} className="team-member">
            <img src={member.image} alt={member.name} className="team-image" />
            <h3 className="member-name"><span className="name-team">{member.name}</span> <br />{member.role}</h3>
            <p className="member-role"></p>
          </div>
        ))}
      </div>
      {/* <button className="view-all-button">View All Experts</button> */}
    </div>
    
  )
}


export default Team;
